import styled from 'styled-components';
import { Image } from 'react-bootstrap';

export const CalculatorIcon = styled(Image)`
  width: 11.38px;
  height: 13px;
  cursor: pointer;
`;
